import { NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChartBarComponent } from './chart-bar.component';
import type { ChartData } from './chart.types';
import { ChartType } from './chart.types';

@Component({
  standalone: true,
  imports: [NgSwitch, NgSwitchCase, ChartBarComponent],
  selector: 'fl-chart',
  template: `
    <ng-container [ngSwitch]="type">
      <fl-chart-bar
        *ngSwitchCase="ChartType.BAR"
        [data]="data"
        [barSpacing]="barSpacing"
        [gridScale]="gridScale"
        [markerYSuffix]="markerYSuffix"
      ></fl-chart-bar>
    </ng-container>
  `,
  styleUrls: ['./chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartComponent {
  ChartType = ChartType;

  @Input() type: ChartType;
  @Input() data: readonly ChartData[];
  @Input() gridScale = 2;
  @Input() barSpacing = 10;
  @Input() markerYSuffix = '';
}
